import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-4xl font-medium capitalize" }
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap gap-4"
}
const _hoisted_6 = { key: 1 }

import { PropType, ref } from "vue";
import { storeToRefs } from "pinia";

import RouterButton from "@/components/RouterButton.vue";
import ResourceCard from "@/components/resources/ResourceCard.vue";

import { Resource } from "@/types";
import { useGlobalStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceCards',
  props: {
  role: {
    type: String,
    required: true,
  },
  resources: {
    type: Array as PropType<Resource[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { user_roles: roles } = storeToRefs(useGlobalStore());



const fullNameRole = ref("");

function getRoleDisplayName(role: string) {
  const roleObj = roles.value.find(r => r.name === role);
  if (roleObj) {
    return roleObj.display_name;
  }
  return role;
}

fullNameRole.value = getRoleDisplayName(props.role);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("role-resources", [fullNameRole.value])), 1),
      _createVNode(RouterButton, {
        to: { name: 'Resources' },
        type: "primary",
        class: "mt-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("view-resources")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.resources.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resources, (resource) => {
              return (_openBlock(), _createBlock(ResourceCard, {
                key: resource.id,
                resource: resource
              }, null, 8, ["resource"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("no-resources", [fullNameRole.value])), 1))
    ])
  ]))
}
}

})